module.exports = __webpack_public_path__ + "static/img/photo.d286efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo.png
// module id = JgJ5
// module chunks = 1